import React from 'react';
import BusinessPage from '../pages/BusinessPage';
import './VistaPreviaNegocio.css';

/**
 * La página pública del negocio, dentro del onboarding.
 *
 * No es una maqueta: monta el mismo `BusinessPage` que sirve `/<slug>`, con los
 * datos que todavía no se guardaron. Lo que se ve acá es exactamente lo que van
 * a ver los clientes, incluidos los colores elegidos.
 *
 * `BusinessPage` en modo `datosPreview` no pega a la API, no escribe en
 * localStorage y tiene la reserva deshabilitada.
 *
 * Va dentro de un contenedor con su propio scroll y, en pantallas grandes, con
 * un `zoom` que achica el conjunto: la página está pensada para ocupar toda la
 * ventana y acá entra en una columna del onboarding.
 */
/**
 * `alto` es opcional y solo para forzar una medida puntual. Sin él, el alto lo
 * pone el CSS en función de la ventana: eran 560px fijos, y en un monitor
 * quedaban 300px de página desaprovechados debajo mientras la vista previa
 * mostraba apenas el encabezado del negocio.
 *
 * `completa` saca el marco con scroll y muestra la página entera. Sirve para el
 * último paso, donde lo que se está confirmando es la página: con el marco
 * quedaban dos zonas de scroll, una adentro de la otra —la del paso y la de la
 * vista previa—, y no se entendía cuál se estaba moviendo con la rueda.
 */
const VistaPreviaNegocio = ({ datos, alto, completa = false }) => {
  if (!datos) return null;

  return (
    <figure className="vista-previa">
      <figcaption className="vista-previa-barra">
        <span className="vista-previa-punto" aria-hidden="true"></span>
        Así se ve tu página
      </figcaption>

      <div
        className={completa ? 'vista-previa-marco vista-previa-marco-completa' : 'vista-previa-marco'}
        style={!completa && alto ? { height: typeof alto === 'number' ? `${alto}px` : alto } : undefined}
      >
        <div className="vista-previa-contenido">
          <BusinessPage datosPreview={datos} />
        </div>
      </div>
    </figure>
  );
};

export default VistaPreviaNegocio;
